import { useSelector } from 'react-redux';

function useSubscription() {
	const user = useSelector((state) => state.userInfo?.userInfo?.data);
	const subscription = user?.subscription;
	const isSubscribed = user?.is_subscribed;
	const isSubscriptionFree = subscription?.is_free;
	const isSubscriptionActive = subscription?.is_active;
	const isSubscriptionExpired = subscription?.is_expired;
	const isSubscriptionRecurring = subscription?.is_recurring;
	const subscriptionBillingPeriod = subscription?.billing_period;
	const subscriptionPaymentMethod = subscription?.payment_details?.method;
	const subscriptionScheduledForCancellation = subscription?.is_scheduled_for_cancellation;
	const subscriptionNextBillingDate = subscription?.next_billing_date;
	const subscriptionStatus = subscription?.status;
	const isSubscriptionPaused = subscription?.status === 'Paused';
	const isSubscriptionCancelled = subscription?.status === 'Cancelled';
	// Backend returns the human display status (getDisplayStatus), not the raw
	// enum — 'created'/'authenticated' both surface as 'Payment Pending'.
	const isPendingPayment = subscription?.status === 'Payment Pending';
	// Distinct from isPendingPayment above: that is true when the CURRENT plan
	// itself is unpaid (a brand-new subscriber). This is true when an existing,
	// fully active plan has a separate upgrade/downgrade replacement waiting on
	// a new mandate — the case where nothing else on `subscription` hints that
	// a change is in flight, because `subscription` is still the OLD plan.
	const pendingChange = subscription?.pending_change ?? null;
	const hasPendingChange = Boolean(pendingChange);

	return {
		subscription,
		isSubscribed,
		isSubscriptionFree,
		subscriptionStatus,
		isSubscriptionRecurring,
		isSubscriptionExpired,
		isSubscriptionActive,
		subscriptionBillingPeriod,
		subscriptionPaymentMethod,
		subscriptionScheduledForCancellation,
		subscriptionNextBillingDate,
		isSubscriptionPaused,
		isSubscriptionCancelled,
		isPendingPayment,
		pendingChange,
		hasPendingChange,
	};
}

export default useSubscription;
